import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import PartnershipInquiryForm from "./components/PartnershipInquiryForm";
export default function PartnershipsPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Partnerships · Inquiries welcome"
          title="Build something meaningful. Together."
        >
          <p>
            We welcome organizations that share our commitment to African
            development, local capability, and lasting economic opportunity.
          </p>
          <a className="button button-green" href="#partner-form">
            Start a Partnership Conversation ↗
          </a>
        </PageIntro>
        <section className="section-space">
          <div className="shell purpose-grid">
            <div>
              <p className="eyebrow">Shared purpose</p>
              <h2>
                Local priorities.
                <br />
                Collective contribution.
              </h2>
            </div>
            <div>
              <p className="large-copy">
                A good partnership begins with listening to the people it
                intends to serve.
              </p>
              <p className="body-copy">
                We are developing relationships with educators, community
                organizations, diaspora networks, enterprises, and institutions.
                Together, we can explore initiatives that bring practical
                knowledge, professional skills, and enterprise support closer to
                communities.
              </p>
              <p className="body-copy">
                Each collaboration should define who participates, what each
                partner contributes, and how progress will be assessed. We
                welcome a small, well-defined first step.
              </p>
            </div>
          </div>
        </section>
        <section className="section-space bg-[#F8F6F3]">
          <div className="shell">
            <p className="eyebrow">Areas to explore</p>
            <h2>Where our ambitions can meet.</h2>
            <div className="pillar-grid">
              {[
                {
                  title: "Learning & skills",
                  text: "Explore financial literacy workshops, education partnerships, or future workforce development programs.",
                },
                {
                  title: "Enterprise & community",
                  text: "Discuss practical support for entrepreneurs and locally defined economic priorities.",
                },
                {
                  title: "Diaspora connections",
                  text: "Bring knowledge, mentorship, and professional relationships into conversations about African opportunity.",
                },
              ].map((x) => (
                <div className="pillar-card" key={x.title}>
                  <h3>{x.title}</h3>
                  <p>{x.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <PartnershipInquiryForm />
      </main>
      <Footer />
    </>
  );
}
